const addNonInteractionProps = (params) => {
  if (Object.keys(params).includes('nonInteraction')) return params;
  return { ...params, nonInteraction: 0 };
};

export const track = (eventName, params) => {
  if (!window.analytics) return;

  const properties = addNonInteractionProps(params);

  window.analytics.track(eventName, properties);
};
